module.exports = __webpack_public_path__ + "static/media/postcardOne.bafdeb8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/postcardOne.png
// module id = 994
// module chunks = 0